import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { SidebarComponent } from '../components/sidebar/sidebar.component';
import { DashboardHeaderComponent } from '../components/dashboard-header/dashboard-header.component';
import { MobileBottomNavComponent } from '../components/mobile-bottom-nav/mobile-bottom-nav.component';
import { Store } from '@ngrx/store';
import { selectAuthLoading, selectAuthStatus } from '../../store/auth/auth.selectors';
import { LoadingOverlayComponent } from '../../shared/components/loading-overlay/loading-overlay.component';
import { map } from 'rxjs/operators';

@Component({
    selector: 'app-customer-layout',
    standalone: true,
    imports: [CommonModule, RouterOutlet, SidebarComponent, DashboardHeaderComponent, MobileBottomNavComponent, LoadingOverlayComponent],
    templateUrl: './customer-layout.component.html',
    styleUrls: ['./customer-layout.component.scss'],
})
export class CustomerLayoutComponent {
    private store = inject(Store);
    loading$ = this.store.select(selectAuthLoading);
    mobileNavOpen = false;

    navigation$ = this.store.select(selectAuthStatus).pipe(
        map(({ user }) => {
            const codesRaw = (user as any)?.permission_codes ?? (user as any)?.permissionCodes ?? [];
            const codes = Array.isArray(codesRaw) ? codesRaw.map((v: any) => String(v).trim().toLowerCase()) : [];
            const perms = new Set(codes);

            const nav: Array<{ name: string; href: string; icon: string }> = [
                { name: "Reservations", href: "/customer-dashboard/reservations", icon: "calendar" }
            ];

            if (perms.has('offers:read')) {
                nav.push({ name: "Offers", href: "/customer-dashboard/offers", icon: "file-text" });
            }

            return nav;
        })
    );

    customerNavigation = [
        { name: "Reservations", href: "/customer-dashboard/reservations", icon: "calendar" }
    ];
}
